import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { LINKS } from "@/lib/links";

export default function PageNav({ ctaHref, ctaLabel, ctaTestId, onCtaClick }) {
  return (
    <nav
      data-testid="page-nav"
      className="fixed top-0 left-0 right-0 z-[60] h-14 sm:h-16 flex items-center justify-between px-4 bg-[#030712]/80 backdrop-blur-xl border-b border-[#00A3FF]/10"
    >
      <Link
        to="/"
        className="font-display text-sm font-bold tracking-wide text-white hover:text-[#E9FF00] transition-colors"
        data-testid="nav-home"
      >
        LUQMANAN
      </Link>

      <div className="flex items-center gap-2 sm:gap-3">
        <a
          href={LINKS.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-instagram-link"
          className="w-9 h-9 flex items-center justify-center rounded-sm border border-[#00A3FF]/15 hover:border-[#E9FF00]/40 hover:bg-[#E9FF00]/5 transition-colors"
          aria-label="Instagram"
        >
          <Instagram className="w-4 h-4 text-[#8B9CC7]" />
        </a>
        {ctaHref ? (
          <a
            href={ctaHref}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={ctaTestId || "nav-cta"}
            onClick={onCtaClick}
            className="game-btn-primary flex items-center gap-2 text-[10px] sm:text-xs uppercase tracking-wider px-3 sm:px-4 py-2 sm:py-2.5"
          >
            {ctaLabel}
          </a>
        ) : null}
      </div>
    </nav>
  );
}
